'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Copyright (C) 2018 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */
var REGULAR_KEYS = exports.REGULAR_KEYS = {
  RIGHT_MOUSE_BUTTON: 3,
  BACKSPACE: 8,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  DELETE: 46,
  D: 68,
  F: 70
};

var SPECIAL_KEYS = exports.SPECIAL_KEYS = ['alt', 'control', 'meta', 'shift'];